import { useState } from "react";
import { api } from "../../../lib/api";
import { toast } from "sonner";
import { Plus } from "lucide-react";

export function BookingReminders({ data, reference, reload }) {
  const [form, setForm] = useState({ title: "", due_date: "" });
  const add = async () => {
    if (!form.title.trim()) return;
    try { await api.post("/admin/reminders", { ...form, reference }); setForm({ title: "", due_date: "" }); reload(); }
    catch (e) { toast.error(e?.response?.data?.detail || "Could not add"); }
  };
  const toggle = async (r) => { await api.patch(`/admin/reminders/${r.id}`, { status: r.status === "open" ? "done" : "open" }); reload(); };
  return (
    <div data-testid="jobfile-reminders">
      <div className="border border-[#E5E7EB] bg-white p-3 mb-4 flex flex-col sm:flex-row gap-2">
        <input data-testid="jobrem-title" value={form.title} onChange={e => setForm({ ...form, title: e.target.value })} placeholder="Reminder for this client…" className="border border-[#E5E7EB] px-3 py-2 text-sm flex-1" />
        <input data-testid="jobrem-due" type="date" value={form.due_date} onChange={e => setForm({ ...form, due_date: e.target.value })} className="border border-[#E5E7EB] px-3 py-2 text-sm" />
        <button data-testid="jobrem-add" onClick={add} className="de-btn-primary shrink-0"><Plus size={16} /> Add</button>
      </div>
      <div className="space-y-2">
        {(data.reminders || []).map(r => (
          <div key={r.id} className="border border-[#E5E7EB] bg-white p-3 flex items-center gap-3 text-sm">
            <button onClick={() => toggle(r)} className={`w-4 h-4 border shrink-0 ${r.status === "done" ? "bg-[#C79A3B] border-[#C79A3B]" : "border-[#12263A]"}`} />
            <span className={r.status === "done" ? "line-through text-[#6B7280]" : ""}>{r.title}</span>
            {r.due_date && <span className="text-xs text-[#6B7280] ml-auto">{new Date(r.due_date).toLocaleDateString("en-GB")}</span>}
          </div>
        ))}
        {(data.reminders || []).length === 0 && <div className="text-sm text-[#6B7280]">No reminders for this client.</div>}
      </div>
    </div>
  );
}
